// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-card-title class="title">QR Code</v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row>
            <v-flex xs12>
              <div class="text-xs-center">
                <canvas ref="qr"></canvas>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <template v-for="(field, i) in fields">
              <v-flex xs12 sm4 :key="i">
                <template v-if="field.type=='checkbox'" align-end style="rgba(0,0,0,.50);">
                  <v-checkbox
                  :label="field.label"
                    :value="getElement(value, field.key)"
                    @change="(val) => changeElement(value, field.key, val)"
                    hide-details
                  ></v-checkbox>
                </template>
                <v-text-field v-else
                  :value="getElement(value, field.key)"
                  @input="(val) => changeElement(value, field.key, val)"
                  :label="field.label"
                  hide-details
                  >
                </v-text-field>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import QRious from 'qrious'

export default {
  data () {
    return {
      code: null,
      value: {},
      fields: [
        {
          key: 'airplaneMode',
          label: 'Airplane Mode',
          type: 'checkbox'
        },
        {
          key: 'bluetoothEnabled',
          label: 'Bluetooth Enabled',
          type: 'checkbox'
        },
        {
          key: 'cellDataState',
          label: 'Cell Data Enabled',
          type: 'checkbox'
        },
        {
          key: 'displayAutoBrightness',
          label: 'Display Auto Brightness',
          type: 'checkbox'
        },
        {
          key: 'displayBrightness',
          label: 'Display Brightness'
        },
        {
          key: 'displayTimeout',
          label: 'Display Timeout'
        },
        {
          key: 'lockScreenSettings',
          label: 'Lock Screen Settings',
          type: 'checkbox'
        },
        {
          key: 'mediaVolume',
          label: 'Media Volume'
        },
        {
          key: 'nfcEnabled',
          label: 'NFC Enabled',
          type: 'checkbox'
        },
        {
          key: 'notificationVolume',
          label: 'Nofitication Volume'
        },
        {
          key: 'ringVolume',
          label: 'Ring Volume'
        },
        {
          key: 'wifi.ssid',
          label: 'Wifi SSID'
        },
        {
          key: 'wifi.enabled',
          label: 'Wifi Enabled',
          type: 'checkbox'
        }
      ]
    }
  },

  mounted () {
    this.code = this.newCode(this.value)
  },

  methods: {
    changeElement: function (item, path, value, type) {
      var splitPath = path.split('.')
      var obj = item
      for (var i = 0; i < splitPath.length - 1; i++) {
        var pathSeg = splitPath[i]
        if (pathSeg in obj) {
          obj = obj[pathSeg]
        } else {
          obj[pathSeg] = {}
          obj = obj[pathSeg]
        }
      }
      if (type === 'number') {
        value = parseFloat(value)
      }
      this.$set(obj, splitPath[splitPath.length - 1], value)
      this.code = this.newCode(this.value)
    },

    getElement: function (item, element) {
      var path = element.split('.')
      var obj = item
      while (path.length) {
        if (obj) {
          obj = obj[path.shift()]
        } else {
          return ''
        }
      }
      return obj
    },

    newCode: function (value) {
      return new QRious({
        element: this.$refs.qr,
        level: 'H',
        padding: 0,
        size: 300,
        value: JSON.stringify(value)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QRCode.vue